import ReviewerRole from './ReviewerRole'

export default class NewReviewer extends ReviewerRole {
}
